import { render, staticRenderFns } from "./SoalStart.vue?vue&type=template&id=184cf14c&scoped=true"
import script from "./SoalStart.vue?vue&type=script&lang=js"
export * from "./SoalStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cf14c",
  null
  
)

export default component.exports